import { ProfileData } from "../../common/common.model";
import { USER_INFO_ACTIONS } from "../thunks/userInfo.thunk";
interface ProfileDataProps {
  email: string;
  family_name: string;
  given_name: string;
  picture: string;
  username: string;
  loading?: boolean;
  error?: {};
  data?: ProfileData;
}

interface userInfoProps {
  profileData: ProfileDataProps;
  rolesData: any;
}

const initialState: userInfoProps = {
  profileData: { loading: true } as ProfileDataProps,
  rolesData: {},
};

export default function userInfoReducer(state = initialState, action: any) {
  switch (action.type) {
    case USER_INFO_ACTIONS.SET_USER_PROFILE_DATA:
      state = {
        ...state,
        profileData: { ...state.profileData, ...action.payload },
      };
      return state;

    case USER_INFO_ACTIONS.SET_AVAILABLE_ROLES:
      state = {
        ...state,
        rolesData: { ...state.rolesData, ...action.payload },
      };
      return state;
    default:
      return state;
  }
}
